import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const Header = () => {
    const [showMenu, setShowMenu] = useState(false);
    return (
        <>
            <header id="site-header">
                <div className="site-container d-flex align-items-center justify-content-between">
                    <div className="logo">
                        <Link to="/">
                            <img src="assets/images/rsslogo.png" height="70px" alt="logo" />
                        </Link>
                    </div>
                    <nav id="nav" className={showMenu ? 'active' : ''}>
                        <button className="close-menu" onClick={() => setShowMenu(false)}>
                            <img src="assets/images/icons/close.svg" alt="" />
                        </button>
                        <ul onClick={() => setShowMenu(false)}>
                            <li>
                                <NavLink exact activeClassName="active" to="/">HOME</NavLink>
                            </li>
                            <li>
                                <NavLink activeClassName="active" to="/about">ABOUT</NavLink>
                            </li>
                            <li>
                                <NavLink activeClassName="active" to="/projects">PROJECTS</NavLink>
                            </li>
                            <li>
                                <NavLink activeClassName="active" to="/gallery">GALLERY</NavLink>
                            </li>
                            <li>
                                <NavLink activeClassName="active" to="/clients">CLIENTS</NavLink>
                            </li>
                            <li>
                                <NavLink activeClassName="active" to="/contact">CONTACT US</NavLink>
                            </li>
                        </ul>
                    </nav>
                    <Link to="/contact" className="button d-none d-lg-block">Enquire Now</Link>
                    <button className="hambuger" onClick={() => setShowMenu(true)}>
                        <img alt="" src="assets/images/icons/navicon.svg" />
                    </button>
                </div>
            </header>
        </>
    )
}

export default Header;